// extracted by mini-css-extract-plugin
export default {"profile-relation":"Badge_profile-relation__+cyJD","beige":"Badge_beige__4yy+e","green":"Badge_green__PSX4Z","blue":"Badge_blue__QStbr","purple":"Badge_purple__jaTXT"};